module.exports = __webpack_public_path__ + "img/794911f5d8b92652d4bc413bc7ba1769.svg";